import ImageGridComponent from '@molecules/ImageGridComponent/ImageGridComponent';
import { EcommerceEvent, pushGTMEcommerceEvent } from '@helpers/analyticsHelpers/pushGTMEvent';
import TrackedComponent from '@organisms/TrackedComponent/TrackedComponent';

interface Props {
  data: ImageGridComponentType;
}

const TrackedImageGridComponent = ({ data }: Props) => {
  const logImpression = () => {
    pushGTMEcommerceEvent({
      event: EcommerceEvent.VIEW_PROMOTION,
      ecommerce: {
        promotion_id: data.code || 'image_grid_component',
        creative_name: 'image_grid_component',
        creative_slot: '',
      },
    });
  };

  const onClick = () => {
    pushGTMEcommerceEvent({
      event: EcommerceEvent.SELECT_PROMOTION,
      ecommerce: {
        promotion_id: data.code || 'image_grid_component',
        creative_name: 'image_grid_component',
        creative_slot: '',
      },
    });
  };

  return (
    <TrackedComponent onInView={logImpression}>
      <ImageGridComponent data={data} onClick={onClick} />
    </TrackedComponent>
  );
};

export default TrackedImageGridComponent;
